/**
 * Core logic: Copies text to the clipboard using the modern API.
 * Exporting this allows you to use the function in other files.
 */
export async function writeClipboardText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error("Clipboard error:", error.message);
    return false;
  }
}

/**
 * Initialization function: Attaches the UI logic.
 * We wrap this so it doesn't run automatically upon import unless you want it to.
 */
export function initClipboardButton() {
  const clipButton = document.querySelector('.copy-clipboard');
  const clipFeedback = document.getElementById('copied');
  const clipFeedbackAria = document.getElementById('copied-aria');

  // Guard clause to prevent errors if elements aren't on the current page
  if (!clipButton || !clipFeedback) return;

  clipButton.addEventListener("click", () => {
    const textToCopy = clipButton.dataset.clipboardText;

    writeClipboardText(textToCopy).then((success) => {
      if (success) {
        clipFeedback.textContent = 'Details copied!';
        if (clipFeedbackAria) clipFeedbackAria.textContent = 'Details copied!';
        
        clipFeedback.classList.add('hide');
      }
    });
  });
}
